// extracted by mini-css-extract-plugin
module.exports = {"postsBlock":"styles_postsBlock__YdKcQ","btnWrp":"styles_btnWrp__UxW4k","mentionSuggestions":"styles_mentionSuggestions__2yMuA"};